import { UnorderedList } from '@src/components/List'
import * as React from 'react'
import { MenuWrapper } from '../styles'
import RecheckMenuitems from './RecheckMenuitems'
import * as Types from './types'

const Rechecks: React.FunctionComponent<Types.Rechecks> = ({
  hasMinText,
  checksRunning,
}) => {
  return (
    <MenuWrapper>
      <UnorderedList>
        <RecheckMenuitems hasMinText={hasMinText} checksRunning={checksRunning} />
      </UnorderedList>
    </MenuWrapper>
  )
}

export default Rechecks



// WEBPACK FOOTER //
// ./src/layouts/shared/Recheck/Rechecks.tsx